export const DEFAULT_INPUT_DEBOUNCE_DELAY = 500;
export const DEFAULT_INPUT_RICH_TEXT_FONT_FAMILY = 'Arial';
